const getters = {
  weightMultipier: state => {
    return state.weightMultipier;
  },
  selectedWeightMultipier: state => {
    return state.selectedWeightMultipier;
  },
  showedWeightMultipier: state => {
    return state.showedWeightMultipier;
  },
  basket: state => {
    return state.basket;
  },
  productGroups: state => {
    return state.productGroups;
  }
};

export default getters;
